export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/www/resources/js/pages/shared/index.vue'),
    /* no children */
    meta: {
      "sector": "shared",
      "allowed_user_types": [
        "customer",
        "employee"
      ]
    }
  },
  {
    path: '/attachment',
    /* internal name: '/attachment' */
    /* no component */
    children: [
      {
        path: ':id/view',
        name: '/attachment/[id]/view',
        component: () => import('/www/resources/js/pages/shared/attachment/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "shared",
          "allowed_user_types": [
            "customer",
            "employee"
          ]
        }
      },
      {
        path: 'create/:type/:id',
        name: '/attachment/create/[type]/[id]',
        component: () => import('/www/resources/js/pages/shared/attachment/create.[type].[id].vue'),
        /* no children */
        meta: {
          "sector": "shared",
          "allowed_user_types": [
            "customer",
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: 'account',
        name: '/auth/account',
        component: () => import('/www/resources/js/pages/shared/auth/account.vue'),
        /* no children */
        meta: {
          "sector": "shared",
          "allowed_user_types": [
            "customer",
            "employee"
          ]
        }
      },
      {
        path: 'login',
        /* internal name: '/auth/login' */
        /* no component */
        children: [
          {
            path: '',
            name: '/auth/login',
            component: () => import('/www/resources/js/pages/shared/auth/login/index.vue'),
            alias: ["/login"],
            /* no children */
            meta: {
              "allowed_user_types": [
                "guest",
                "customer",
                "employee"
              ],
              "fullscreen": true,
              "sector": "shared"
            }
          },
          {
            path: 'sso',
            name: '/auth/login/sso',
            component: () => import('/www/resources/js/pages/shared/auth/login/sso.vue'),
            alias: ["/sso/app/login"],
            /* no children */
            meta: {
              "allowed_user_types": [
                "guest",
                "customer",
                "employee"
              ],
              "fullscreen": true,
              "sector": "shared"
            }
          }
        ],
      },
      {
        path: 'logout',
        name: '/auth/logout',
        component: () => import('/www/resources/js/pages/shared/auth/logout.vue'),
        alias: ["/logout"],
        /* no children */
        meta: {
          "fullscreen": true,
          "sector": "shared",
          "allowed_user_types": [
            "customer",
            "employee"
          ]
        }
      },
      {
        path: 'pincode',
        name: '/auth/pincode',
        component: () => import('/www/resources/js/pages/shared/auth/pincode.vue'),
        /* no children */
        meta: {
          "sector": "shared",
          "allowed_user_types": [
            "customer",
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/configurations',
    name: '/configurations',
    component: () => import('/www/resources/js/pages/customer/configurations.vue'),
    children: [
      {
        path: 'customfields',
        /* internal name: '/configurations/customfields' */
        /* no component */
        children: [
          {
            path: '',
            name: '/configurations/customfields',
            component: () => import('/www/resources/js/pages/customer/configurations/customfields/index.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          },
          {
            path: ':id/edit',
            name: '/configurations/customfields/[id]/edit',
            component: () => import('/www/resources/js/pages/customer/configurations/customfields/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          }
        ],
      },
      {
        path: 'poolfilters',
        /* internal name: '/configurations/poolfilters' */
        /* no component */
        children: [
          {
            path: '',
            name: '/configurations/poolfilters',
            component: () => import('/www/resources/js/pages/customer/configurations/poolfilters/index.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          },
          {
            path: ':id/edit',
            name: '/configurations/poolfilters/[id]/edit',
            component: () => import('/www/resources/js/pages/customer/configurations/poolfilters/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          }
        ],
      }
    ],
    meta: {
      "sector": "customer",
      "allowed_user_types": [
        "customer"
      ]
    }
  },
  {
    path: '/crm',
    /* internal name: '/crm' */
    /* no component */
    children: [
      {
        path: 'customer',
        /* internal name: '/crm/customer' */
        /* no component */
        children: [
          {
            path: ':customerId',
            name: '/crm/customer/[customerId]:parent',
            component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId].vue'),
            children: [
              {
                path: '',
                name: '/crm/customer/[customerId]',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'address/:id',
                name: '/crm/customer/[customerId]/address/[id]',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/address.[id].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'contact/:id',
                name: '/crm/customer/[customerId]/contact/[id]',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/contact.[id].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'contract',
                /* internal name: '/crm/customer/[customerId]/contract' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/crm/customer/[customerId]/contract',
                    component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/contract/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id',
                    name: '/crm/customer/[customerId]/contract/[id]',
                    component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/contract/[id].vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'edit',
                name: '/crm/customer/[customerId]/edit',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'email/:id',
                name: '/crm/customer/[customerId]/email/[id]',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/email.[id].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'financial',
                /* internal name: '/crm/customer/[customerId]/financial' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/crm/customer/[customerId]/financial',
                    component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/financial/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'interncontact/:id',
                name: '/crm/customer/[customerId]/interncontact/[id]',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/interncontact.[id].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'invoices',
                name: '/crm/customer/[customerId]/invoices',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/invoices.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'lims/:id',
                name: '/crm/customer/[customerId]/lims/[id]',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/lims.[id].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'location',
                /* internal name: '/crm/customer/[customerId]/location' */
                /* no component */
                children: [
                  {
                    path: ':locationId',
                    /* internal name: '/crm/customer/[customerId]/location/[locationId]' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '/crm/customer/[customerId]/location/[locationId]',
                        component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/location/[locationId]/index.vue'),
                        /* no children */
                        meta: {
                          "sector": "internal",
                          "allowed_user_types": [
                            "employee"
                          ]
                        }
                      },
                      {
                        path: 'pools',
                        name: '/crm/customer/[customerId]/location/[locationId]/pools',
                        component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/location/[locationId]/pools.vue'),
                        /* no children */
                        meta: {
                          "sector": "internal",
                          "allowed_user_types": [
                            "employee"
                          ]
                        }
                      },
                      {
                        path: 'project',
                        /* internal name: '/crm/customer/[customerId]/location/[locationId]/project' */
                        /* no component */
                        children: [
                          {
                            path: '',
                            name: '/crm/customer/[customerId]/location/[locationId]/project',
                            component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/location/[locationId]/project/index.vue'),
                            /* no children */
                            meta: {
                              "sector": "internal",
                              "allowed_user_types": [
                                "employee"
                              ]
                            }
                          }
                        ],
                      },
                      {
                        path: 'samplelocation',
                        /* internal name: '/crm/customer/[customerId]/location/[locationId]/samplelocation' */
                        /* no component */
                        children: [
                          {
                            path: '',
                            name: '/crm/customer/[customerId]/location/[locationId]/samplelocation',
                            component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/location/[locationId]/samplelocation/index.vue'),
                            /* no children */
                            meta: {
                              "sector": "internal",
                              "allowed_user_types": [
                                "employee"
                              ]
                            }
                          },
                          {
                            path: ':id',
                            /* internal name: '/crm/customer/[customerId]/location/[locationId]/samplelocation/[id]' */
                            /* no component */
                            children: [
                              {
                                path: 'edit',
                                name: '/crm/customer/[customerId]/location/[locationId]/samplelocation/[id]/edit',
                                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/location/[locationId]/samplelocation/[id]/edit.vue'),
                                /* no children */
                                meta: {
                                  "sector": "internal",
                                  "allowed_user_types": [
                                    "employee"
                                  ]
                                }
                              },
                              {
                                path: 'view',
                                name: '/crm/customer/[customerId]/location/[locationId]/samplelocation/[id]/view',
                                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/location/[locationId]/samplelocation/[id]/view.vue'),
                                /* no children */
                                meta: {
                                  "sector": "internal",
                                  "allowed_user_types": [
                                    "employee"
                                  ]
                                }
                              }
                            ],
                          }
                        ],
                      }
                    ],
                  }
                ],
              },
              {
                path: 'location/:id',
                name: '/crm/customer/[customerId]/location/[id]',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/location.[id].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'logbook',
                /* internal name: '/crm/customer/[customerId]/logbook' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/crm/customer/[customerId]/logbook',
                    component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/logbook/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/crm/customer/[customerId]/logbook/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/logbook/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'phonenumber/:id',
                name: '/crm/customer/[customerId]/phonenumber/[id]',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/phonenumber.[id].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'product',
                /* internal name: '/crm/customer/[customerId]/product' */
                /* no component */
                children: [
                  {
                    path: 'codes',
                    /* internal name: '/crm/customer/[customerId]/product/codes' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '/crm/customer/[customerId]/product/codes',
                        component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/product/codes/index.vue'),
                        /* no children */
                        meta: {
                          "sector": "internal",
                          "allowed_user_types": [
                            "employee"
                          ]
                        }
                      },
                      {
                        path: ':id',
                        name: '/crm/customer/[customerId]/product/codes/[id]',
                        component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/product/codes/[id].vue'),
                        /* no children */
                        meta: {
                          "sector": "internal",
                          "allowed_user_types": [
                            "employee"
                          ]
                        }
                      }
                    ],
                  }
                ],
              },
              {
                path: 'scheduled-invoice-items',
                name: '/crm/customer/[customerId]/scheduled-invoice-items',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/scheduled-invoice-items.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'settings',
                /* internal name: '/crm/customer/[customerId]/settings' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/crm/customer/[customerId]/settings',
                    component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/settings/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id',
                    name: '/crm/customer/[customerId]/settings/[id]',
                    component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/settings/[id].vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'users',
                name: '/crm/customer/[customerId]/users',
                component: () => import('/www/resources/js/pages/internal/crm/customer/[customerId]/users.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      },
      {
        path: 'customer/create',
        name: '/crm/customer/create',
        component: () => import('/www/resources/js/pages/internal/crm/customer.create.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'customers',
        name: '/crm/customers',
        component: () => import('/www/resources/js/pages/internal/crm/customers.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/depots',
    name: '/depots',
    component: () => import('/www/resources/js/pages/shared/depots.vue'),
    /* no children */
    meta: {
      "sector": "shared",
      "allowed_user_types": [
        "customer",
        "employee"
      ]
    }
  },
  {
    path: '/devicemanagement',
    /* internal name: '/devicemanagement' */
    /* no component */
    children: [
      {
        path: 'device',
        /* internal name: '/devicemanagement/device' */
        /* no component */
        children: [
          {
            path: '',
            name: '/devicemanagement/device',
            component: () => import('/www/resources/js/pages/internal/devicemanagement/device/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id',
            /* internal name: '/devicemanagement/device/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/devicemanagement/device/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/device/[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/devicemanagement/device/[id]/view',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/device/[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      },
      {
        path: 'devicegroup',
        /* internal name: '/devicemanagement/devicegroup' */
        /* no component */
        children: [
          {
            path: '',
            name: '/devicemanagement/devicegroup',
            component: () => import('/www/resources/js/pages/internal/devicemanagement/devicegroup/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id',
            /* internal name: '/devicemanagement/devicegroup/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/devicemanagement/devicegroup/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/devicegroup/[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/devicemanagement/devicegroup/[id]/view',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/devicegroup/[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'configuration/:id',
            /* internal name: '/devicemanagement/devicegroup/configuration/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/devicemanagement/devicegroup/configuration/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/devicegroup/configuration.[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/devicemanagement/devicegroup/configuration/[id]/view',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/devicegroup/configuration.[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'requirement/:id',
            /* internal name: '/devicemanagement/devicegroup/requirement/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/devicemanagement/devicegroup/requirement/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/devicegroup/requirement.[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      },
      {
        path: 'intervention',
        /* internal name: '/devicemanagement/intervention' */
        /* no component */
        children: [
          {
            path: ':id',
            /* internal name: '/devicemanagement/intervention/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/devicemanagement/intervention/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/intervention/[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/devicemanagement/intervention/[id]/view',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/intervention/[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'action/:id',
            /* internal name: '/devicemanagement/intervention/action/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/devicemanagement/intervention/action/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/intervention/action.[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/devicemanagement/intervention/action/[id]/view',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/intervention/action.[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      },
      {
        path: 'temperature',
        /* internal name: '/devicemanagement/temperature' */
        /* no component */
        children: [
          {
            path: 'approve',
            name: '/devicemanagement/temperature/approve:parent',
            component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/approve.vue'),
            children: [
              {
                path: '',
                name: '/devicemanagement/temperature/approve',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/approve/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view/:id/:name',
                name: '/devicemanagement/temperature/approve/view/[id]/[name]',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/approve/view.[id].[name].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'deviation-reason',
            /* internal name: '/devicemanagement/temperature/deviation-reason' */
            /* no component */
            children: [
              {
                path: '',
                name: '/devicemanagement/temperature/deviation-reason',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/deviation-reason/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: ':id/edit',
                name: '/devicemanagement/temperature/deviation-reason/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/deviation-reason/[id].edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'register',
            /* internal name: '/devicemanagement/temperature/register' */
            /* no component */
            children: [
              {
                path: 'manual',
                name: '/devicemanagement/temperature/register/manual',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/register/manual.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'remeasurement/:id',
                name: '/devicemanagement/temperature/register/remeasurement/[id]',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/register/remeasurement.[id].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'result',
            name: '/devicemanagement/temperature/result:parent',
            component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/result.vue'),
            children: [
              {
                path: '',
                name: '/devicemanagement/temperature/result',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/result/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'edit/:id',
                name: '/devicemanagement/temperature/result/edit/[id]',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/result/edit.[id].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view/:id/:name',
                name: '/devicemanagement/temperature/result/view/[id]/[name]',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/result/view.[id].[name].vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'round',
            /* internal name: '/devicemanagement/temperature/round' */
            /* no component */
            children: [
              {
                path: '',
                name: '/devicemanagement/temperature/round',
                component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/round/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: ':id',
                /* internal name: '/devicemanagement/temperature/round/[id]' */
                /* no component */
                children: [
                  {
                    path: 'devices',
                    name: '/devicemanagement/temperature/round/[id]/devices',
                    component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/round/[id]/devices.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: 'edit',
                    name: '/devicemanagement/temperature/round/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/round/[id]/edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: 'share',
                    name: '/devicemanagement/temperature/round/[id]/share',
                    component: () => import('/www/resources/js/pages/internal/devicemanagement/temperature/round/[id]/share.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/display',
    /* internal name: '/display' */
    /* no component */
    children: [
      {
        path: '',
        name: '/display',
        component: () => import('/www/resources/js/pages/display/index.vue'),
        /* no children */
        meta: {
          "allowed_user_types": [
            "guest",
            "display"
          ],
          "sector": "display",
          "fullscreen": true
        }
      },
      {
        path: 'view',
        name: '/display/view',
        component: () => import('/www/resources/js/pages/display/view.vue'),
        children: [
          {
            path: 'account',
            name: '/display/view/account',
            component: () => import('/www/resources/js/pages/display/view/account.vue'),
            /* no children */
            meta: {
              "sector": "display",
              "allowed_user_types": [
                "display"
              ],
              "fullscreen": true
            }
          },
          {
            path: 'dashboard',
            name: '/display/view/dashboard',
            component: () => import('/www/resources/js/pages/display/view/dashboard.vue'),
            /* no children */
            meta: {
              "sector": "display",
              "allowed_user_types": [
                "display"
              ],
              "fullscreen": true
            }
          },
          {
            path: 'door',
            name: '/display/view/door',
            component: () => import('/www/resources/js/pages/display/view/door.vue'),
            /* no children */
            meta: {
              "sector": "display",
              "allowed_user_types": [
                "display"
              ],
              "fullscreen": true
            }
          },
          {
            path: 'login',
            name: '/display/view/login',
            component: () => import('/www/resources/js/pages/display/view/login.vue'),
            /* no children */
            meta: {
              "sector": "display",
              "allowed_user_types": [
                "display"
              ],
              "fullscreen": true
            }
          },
          {
            path: 'status',
            name: '/display/view/status',
            component: () => import('/www/resources/js/pages/display/view/status.vue'),
            /* no children */
            meta: {
              "sector": "display",
              "allowed_user_types": [
                "display"
              ],
              "fullscreen": true
            }
          }
        ],
        meta: {
          "sector": "display",
          "allowed_user_types": [
            "display"
          ],
          "fullscreen": true
        }
      }
    ],
  },
  {
    path: '/document',
    /* internal name: '/document' */
    /* no component */
    children: [
      {
        path: 'qualityhandbook',
        /* internal name: '/document/qualityhandbook' */
        /* no component */
        children: [
          {
            path: 'category',
            /* internal name: '/document/qualityhandbook/category' */
            /* no component */
            children: [
              {
                path: '',
                name: '/document/qualityhandbook/category',
                component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/category/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: ':categoryId',
                /* internal name: '/document/qualityhandbook/category/[categoryId]' */
                /* no component */
                children: [
                  {
                    path: 'edit',
                    name: '/document/qualityhandbook/category/[categoryId]/edit',
                    component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/category/[categoryId]/edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: 'view',
                    name: '/document/qualityhandbook/category/[categoryId]/view',
                    component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/category/[categoryId]/view.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          },
          {
            path: 'document/:id',
            /* internal name: '/document/qualityhandbook/document/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/document/qualityhandbook/document/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/document.[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'share',
                name: '/document/qualityhandbook/document/[id]/share',
                component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/document.[id]/share.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/document/qualityhandbook/document/[id]/view',
                component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/document.[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'participant/:id',
            /* internal name: '/document/qualityhandbook/participant/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/document/qualityhandbook/participant/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/participant.[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'review/:id',
            /* internal name: '/document/qualityhandbook/review/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/document/qualityhandbook/review/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/review.[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/document/qualityhandbook/review/[id]/view',
                component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/review.[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'version/:id',
            /* internal name: '/document/qualityhandbook/version/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/document/qualityhandbook/version/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/version.[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/document/qualityhandbook/version/[id]/view',
                component: () => import('/www/resources/js/pages/internal/document/qualityhandbook/version.[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/documents',
    /* internal name: '/documents' */
    /* no component */
    children: [
      {
        path: '',
        name: '/documents',
        component: () => import('/www/resources/js/pages/customer/documents/index.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      },
      {
        path: ':id/view',
        name: '/documents/[id]/view',
        component: () => import('/www/resources/js/pages/customer/documents/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      }
    ],
  },
  {
    path: '/feature-flags',
    name: '/feature-flags',
    component: () => import('/www/resources/js/pages/shared/feature-flags.vue'),
    /* no children */
    meta: {
      "customer_allowed": true,
      "label": "Feature flags",
      "sector": "shared",
      "allowed_user_types": [
        "customer",
        "employee"
      ]
    }
  },
  {
    path: '/finance',
    /* internal name: '/finance' */
    /* no component */
    children: [
      {
        path: 'contract',
        /* internal name: '/finance/contract' */
        /* no component */
        children: [
          {
            path: 'approve',
            name: '/finance/contract/approve',
            component: () => import('/www/resources/js/pages/internal/finance/contract/approve.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'update',
            name: '/finance/contract/update',
            component: () => import('/www/resources/js/pages/internal/finance/contract/update.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      },
      {
        path: 'invoice',
        /* internal name: '/finance/invoice' */
        /* no component */
        children: [
          {
            path: '',
            name: '/finance/invoice',
            component: () => import('/www/resources/js/pages/internal/finance/invoice/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id/credit',
            name: '/finance/invoice/[id]/credit',
            component: () => import('/www/resources/js/pages/internal/finance/invoice/[id].credit.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id/edit',
            name: '/finance/invoice/[id]/edit',
            component: () => import('/www/resources/js/pages/internal/finance/invoice/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id/view',
            name: '/finance/invoice/[id]/view',
            component: () => import('/www/resources/js/pages/internal/finance/invoice/[id].view.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'create',
            name: '/finance/invoice/create',
            component: () => import('/www/resources/js/pages/internal/finance/invoice/create.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'group/:groupId',
            name: '/finance/invoice/group/[groupId]',
            component: () => import('/www/resources/js/pages/internal/finance/invoice/group.[groupId].vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'schedule',
            name: '/finance/invoice/schedule',
            component: () => import('/www/resources/js/pages/internal/finance/invoice/schedule.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'scheduled-item',
            /* internal name: '/finance/invoice/scheduled-item' */
            /* no component */
            children: [
              {
                path: '',
                name: '/finance/invoice/scheduled-item',
                component: () => import('/www/resources/js/pages/internal/finance/invoice/scheduled-item/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: ':id/edit',
                name: '/finance/invoice/scheduled-item/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/finance/invoice/scheduled-item/[id].edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'status-checker',
            name: '/finance/invoice/status-checker',
            component: () => import('/www/resources/js/pages/internal/finance/invoice/status-checker.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      },
      {
        path: 'pricechange',
        /* internal name: '/finance/pricechange' */
        /* no component */
        children: [
          {
            path: '',
            name: '/finance/pricechange',
            component: () => import('/www/resources/js/pages/internal/finance/pricechange/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':priceChangeId',
            /* internal name: '/finance/pricechange/[priceChangeId]' */
            /* no component */
            children: [
              {
                path: 'assign-customers',
                name: '/finance/pricechange/[priceChangeId]/assign-customers',
                component: () => import('/www/resources/js/pages/internal/finance/pricechange/[priceChangeId]/assign-customers.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'edit',
                name: '/finance/pricechange/[priceChangeId]/edit',
                component: () => import('/www/resources/js/pages/internal/finance/pricechange/[priceChangeId]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'group/:groupId',
                /* internal name: '/finance/pricechange/[priceChangeId]/group/[groupId]' */
                /* no component */
                children: [
                  {
                    path: 'add-product/:id/edit',
                    name: '/finance/pricechange/[priceChangeId]/group/[groupId]/add-product/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/finance/pricechange/[priceChangeId]/group.[groupId]/add-product.[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: 'edit',
                    name: '/finance/pricechange/[priceChangeId]/group/[groupId]/edit',
                    component: () => import('/www/resources/js/pages/internal/finance/pricechange/[priceChangeId]/group.[groupId]/edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: 'price-adjustment/:id/edit',
                    name: '/finance/pricechange/[priceChangeId]/group/[groupId]/price-adjustment/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/finance/pricechange/[priceChangeId]/group.[groupId]/price-adjustment.[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: 'view',
                    name: '/finance/pricechange/[priceChangeId]/group/[groupId]/view',
                    component: () => import('/www/resources/js/pages/internal/finance/pricechange/[priceChangeId]/group.[groupId]/view.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'view',
                name: '/finance/pricechange/[priceChangeId]/view',
                component: () => import('/www/resources/js/pages/internal/finance/pricechange/[priceChangeId]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      },
      {
        path: 'revenue',
        name: '/finance/revenue',
        component: () => import('/www/resources/js/pages/internal/finance/revenue.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/labhub',
    /* internal name: '/labhub' */
    /* no component */
    children: [
      {
        path: 'ftp-communication',
        name: '/labhub/ftp-communication:parent',
        component: () => import('/www/resources/js/pages/internal/labhub/ftp-communication.vue'),
        children: [
          {
            path: '',
            name: '/labhub/ftp-communication',
            component: () => import('/www/resources/js/pages/internal/labhub/ftp-communication/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':supplier',
            /* internal name: '/labhub/ftp-communication/[supplier]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/labhub/ftp-communication/[supplier]',
                component: () => import('/www/resources/js/pages/internal/labhub/ftp-communication/[supplier]/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'browse',
                name: '/labhub/ftp-communication/[supplier]/browse',
                component: () => import('/www/resources/js/pages/internal/labhub/ftp-communication/[supplier]/browse.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/offline',
    name: '/offline',
    component: () => import('/www/resources/js/pages/shared/offline.vue'),
    alias: ["/login"],
    /* no children */
    meta: {
      "allowed_user_types": [
        "customer",
        "employee",
        "guest",
        "customer",
        "employee"
      ],
      "fullscreen": true,
      "sector": "shared"
    }
  },
  {
    path: '/order',
    /* internal name: '/order' */
    /* no component */
    children: [
      {
        path: '',
        name: '/order',
        component: () => import('/www/resources/js/pages/internal/order/index.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: ':id/view',
        name: '/order/[id]/view',
        component: () => import('/www/resources/js/pages/internal/order/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/orders',
    /* internal name: '/orders' */
    /* no component */
    children: [
      {
        path: '',
        name: '/orders',
        component: () => import('/www/resources/js/pages/customer/orders/index.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      },
      {
        path: ':id/view',
        name: '/orders/[id]/view',
        component: () => import('/www/resources/js/pages/customer/orders/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      },
      {
        path: 'new',
        /* internal name: '/orders/new' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/orders/new/[id]',
            component: () => import('/www/resources/js/pages/customer/orders/new/[id].vue'),
            children: [
              {
                path: 'products',
                name: '/orders/new/[id]/products',
                component: () => import('/www/resources/js/pages/customer/orders/new/[id]/products.vue'),
                /* no children */
                meta: {
                  "step": 4,
                  "sector": "customer",
                  "allowed_user_types": [
                    "customer"
                  ]
                }
              },
              {
                path: 'project',
                name: '/orders/new/[id]/project',
                component: () => import('/www/resources/js/pages/customer/orders/new/[id]/project.vue'),
                /* no children */
                meta: {
                  "step": 2,
                  "sector": "customer",
                  "allowed_user_types": [
                    "customer"
                  ]
                }
              },
              {
                path: 'samples',
                name: '/orders/new/[id]/samples',
                component: () => import('/www/resources/js/pages/customer/orders/new/[id]/samples.vue'),
                /* no children */
                meta: {
                  "step": 3,
                  "sector": "customer",
                  "allowed_user_types": [
                    "customer"
                  ]
                }
              },
              {
                path: 'summary',
                name: '/orders/new/[id]/summary',
                component: () => import('/www/resources/js/pages/customer/orders/new/[id]/summary.vue'),
                /* no children */
                meta: {
                  "step": 5,
                  "sector": "customer",
                  "allowed_user_types": [
                    "customer"
                  ]
                }
              }
            ],
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          },
          {
            path: 'create',
            name: '/orders/new/create',
            component: () => import('/www/resources/js/pages/customer/orders/new/create.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          },
          {
            path: 'template/:id/edit',
            name: '/orders/new/template/[id]/edit',
            component: () => import('/www/resources/js/pages/customer/orders/new/template.[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          }
        ],
      }
    ],
  },
  {
    path: '/pools',
    name: '/pools',
    component: () => import('/www/resources/js/pages/customer/pools.vue'),
    /* no children */
    meta: {
      "sector": "customer",
      "allowed_user_types": [
        "customer"
      ]
    }
  },
  {
    path: '/productportfolio',
    name: '/productportfolio:parent',
    component: () => import('/www/resources/js/pages/internal/productportfolio.vue'),
    children: [
      {
        path: '',
        name: '/productportfolio',
        component: () => import('/www/resources/js/pages/internal/productportfolio/index.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'big-edit',
        name: '/productportfolio/big-edit',
        component: () => import('/www/resources/js/pages/internal/productportfolio/big-edit.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'component',
        /* internal name: '/productportfolio/component' */
        /* no component */
        children: [
          {
            path: ':id/edit',
            name: '/productportfolio/component/[id]/edit',
            component: () => import('/www/resources/js/pages/internal/productportfolio/component/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      },
      {
        path: 'family',
        /* internal name: '/productportfolio/family' */
        /* no component */
        children: [
          {
            path: ':id/edit',
            name: '/productportfolio/family/[id]/edit',
            component: () => import('/www/resources/js/pages/internal/productportfolio/family/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id/view',
            name: '/productportfolio/family/[id]/view',
            component: () => import('/www/resources/js/pages/internal/productportfolio/family/[id].view.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      },
      {
        path: 'group',
        /* internal name: '/productportfolio/group' */
        /* no component */
        children: [
          {
            path: '',
            name: '/productportfolio/group',
            component: () => import('/www/resources/js/pages/internal/productportfolio/group/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id/edit',
            name: '/productportfolio/group/[id]/edit',
            component: () => import('/www/resources/js/pages/internal/productportfolio/group/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id/view',
            name: '/productportfolio/group/[id]/view',
            component: () => import('/www/resources/js/pages/internal/productportfolio/group/[id].view.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      },
      {
        path: 'matrix-overview',
        name: '/productportfolio/matrix-overview',
        component: () => import('/www/resources/js/pages/internal/productportfolio/matrix-overview.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'migration',
        /* internal name: '/productportfolio/migration' */
        /* no component */
        children: [
          {
            path: 'family',
            name: '/productportfolio/migration/family',
            component: () => import('/www/resources/js/pages/internal/productportfolio/migration/family.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'matrix',
            name: '/productportfolio/migration/matrix',
            component: () => import('/www/resources/js/pages/internal/productportfolio/migration/matrix.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      },
      {
        path: 'old',
        name: '/productportfolio/old',
        component: () => import('/www/resources/js/pages/internal/productportfolio/old.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'product',
        /* internal name: '/productportfolio/product' */
        /* no component */
        children: [
          {
            path: ':id/edit',
            name: '/productportfolio/product/[id]/edit',
            component: () => import('/www/resources/js/pages/internal/productportfolio/product/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id/view',
            name: '/productportfolio/product/[id]/view',
            component: () => import('/www/resources/js/pages/internal/productportfolio/product/[id].view.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      },
      {
        path: 'variant',
        /* internal name: '/productportfolio/variant' */
        /* no component */
        children: [
          {
            path: ':id/edit',
            name: '/productportfolio/variant/[id]/edit',
            component: () => import('/www/resources/js/pages/internal/productportfolio/variant/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id/view',
            name: '/productportfolio/variant/[id]/view',
            component: () => import('/www/resources/js/pages/internal/productportfolio/variant/[id].view.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      }
    ],
    meta: {
      "sector": "internal",
      "allowed_user_types": [
        "employee"
      ]
    }
  },
  {
    path: '/project',
    /* internal name: '/project' */
    /* no component */
    children: [
      {
        path: '',
        name: '/project',
        component: () => import('/www/resources/js/pages/internal/project/index.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: ':id/view',
        name: '/project/[id]/view',
        component: () => import('/www/resources/js/pages/internal/project/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/projects',
    /* internal name: '/projects' */
    /* no component */
    children: [
      {
        path: '',
        name: '/projects',
        component: () => import('/www/resources/js/pages/customer/projects/index.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      },
      {
        path: ':id/view',
        name: '/projects/[id]/view',
        component: () => import('/www/resources/js/pages/customer/projects/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      }
    ],
  },
  {
    path: '/report',
    /* internal name: '/report' */
    /* no component */
    children: [
      {
        path: '',
        name: '/report',
        component: () => import('/www/resources/js/pages/internal/report/index.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: ':id/view',
        name: '/report/[id]/view',
        component: () => import('/www/resources/js/pages/internal/report/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'aa/:id/view',
        name: '/report/aa/[id]/view',
        component: () => import('/www/resources/js/pages/internal/report/aa.[id].view.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/reports',
    /* internal name: '/reports' */
    /* no component */
    children: [
      {
        path: ':id/view',
        name: '/reports/[id]/view',
        component: () => import('/www/resources/js/pages/customer/reports/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      }
    ],
  },
  {
    path: '/result',
    /* internal name: '/result' */
    /* no component */
    children: [
      {
        path: 'CompareView',
        name: '/result/CompareView',
        component: () => import('/www/resources/js/pages/internal/result/CompareView.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'DownloadView',
        name: '/result/DownloadView',
        component: () => import('/www/resources/js/pages/internal/result/DownloadView.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/results',
    /* internal name: '/results' */
    /* no component */
    children: [
      {
        path: 'CompareView',
        name: '/results/CompareView',
        component: () => import('/www/resources/js/pages/customer/results/CompareView.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      },
      {
        path: 'DownloadView',
        name: '/results/DownloadView',
        component: () => import('/www/resources/js/pages/customer/results/DownloadView.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      }
    ],
  },
  {
    path: '/sample',
    /* internal name: '/sample' */
    /* no component */
    children: [
      {
        path: ':id/view',
        name: '/sample/[id]/view',
        component: () => import('/www/resources/js/pages/internal/sample/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/samplelocations',
    /* internal name: '/samplelocations' */
    /* no component */
    children: [
      {
        path: '',
        name: '/samplelocations',
        component: () => import('/www/resources/js/pages/customer/samplelocations/index.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      },
      {
        path: ':id',
        /* internal name: '/samplelocations/[id]' */
        /* no component */
        children: [
          {
            path: 'edit',
            name: '/samplelocations/[id]/edit',
            component: () => import('/www/resources/js/pages/customer/samplelocations/[id]/edit.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          },
          {
            path: 'merge',
            name: '/samplelocations/[id]/merge',
            component: () => import('/www/resources/js/pages/customer/samplelocations/[id]/merge.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          },
          {
            path: 'orderpreset/:presetId/edit',
            name: '/samplelocations/[id]/orderpreset/[presetId]/edit',
            component: () => import('/www/resources/js/pages/customer/samplelocations/[id]/orderpreset.[presetId].edit.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          },
          {
            path: 'pool-filter',
            name: '/samplelocations/[id]/pool-filter',
            component: () => import('/www/resources/js/pages/customer/samplelocations/[id]/pool-filter.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          },
          {
            path: 'view',
            name: '/samplelocations/[id]/view',
            component: () => import('/www/resources/js/pages/customer/samplelocations/[id]/view.vue'),
            /* no children */
            meta: {
              "sector": "customer",
              "allowed_user_types": [
                "customer"
              ]
            }
          }
        ],
      }
    ],
  },
  {
    path: '/samples',
    /* internal name: '/samples' */
    /* no component */
    children: [
      {
        path: ':id/view',
        name: '/samples/[id]/view',
        component: () => import('/www/resources/js/pages/customer/samples/[id].view.vue'),
        /* no children */
        meta: {
          "sector": "customer",
          "allowed_user_types": [
            "customer"
          ]
        }
      }
    ],
  },
  {
    path: '/system',
    /* internal name: '/system' */
    /* no component */
    children: [
      {
        path: 'buildingmanager',
        name: '/system/buildingmanager:parent',
        component: () => import('/www/resources/js/pages/internal/system/buildingmanager.vue'),
        children: [
          {
            path: '',
            name: '/system/buildingmanager',
            component: () => import('/www/resources/js/pages/internal/system/buildingmanager/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'building',
            /* internal name: '/system/buildingmanager/building' */
            /* no component */
            children: [
              {
                path: '',
                name: '/system/buildingmanager/building',
                component: () => import('/www/resources/js/pages/internal/system/buildingmanager/building/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: ':id/edit',
                name: '/system/buildingmanager/building/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/system/buildingmanager/building/[id].edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'floor',
            /* internal name: '/system/buildingmanager/floor' */
            /* no component */
            children: [
              {
                path: '',
                name: '/system/buildingmanager/floor',
                component: () => import('/www/resources/js/pages/internal/system/buildingmanager/floor/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: ':id/edit',
                name: '/system/buildingmanager/floor/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/system/buildingmanager/floor/[id].edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'room',
            /* internal name: '/system/buildingmanager/room' */
            /* no component */
            children: [
              {
                path: '',
                name: '/system/buildingmanager/room',
                component: () => import('/www/resources/js/pages/internal/system/buildingmanager/room/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: ':id/edit',
                name: '/system/buildingmanager/room/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/system/buildingmanager/room/[id].edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'signs',
            name: '/system/buildingmanager/signs',
            component: () => import('/www/resources/js/pages/internal/system/buildingmanager/signs.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'configuration',
        name: '/system/configuration:parent',
        component: () => import('/www/resources/js/pages/internal/system/configuration.vue'),
        children: [
          {
            path: '',
            name: '/system/configuration',
            component: () => import('/www/resources/js/pages/internal/system/configuration/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'connect',
            /* internal name: '/system/configuration/connect' */
            /* no component */
            children: [
              {
                path: 'exact',
                /* internal name: '/system/configuration/connect/exact' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/connect/exact',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/connect/exact/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          },
          {
            path: 'crm',
            /* internal name: '/system/configuration/crm' */
            /* no component */
            children: [
              {
                path: 'addresstype',
                /* internal name: '/system/configuration/crm/addresstype' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/crm/addresstype',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/addresstype/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/crm/addresstype/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/addresstype/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'gender',
                /* internal name: '/system/configuration/crm/gender' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/crm/gender',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/gender/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/crm/gender/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/gender/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'label',
                /* internal name: '/system/configuration/crm/label' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/crm/label',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/label/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/crm/label/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/label/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'labelcategory',
                /* internal name: '/system/configuration/crm/labelcategory' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/crm/labelcategory',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/labelcategory/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/crm/labelcategory/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/labelcategory/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'lims',
                /* internal name: '/system/configuration/crm/lims' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/crm/lims',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/lims/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'phonetype',
                /* internal name: '/system/configuration/crm/phonetype' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/crm/phonetype',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/phonetype/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/crm/phonetype/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/crm/phonetype/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          },
          {
            path: 'customfields',
            /* internal name: '/system/configuration/customfields' */
            /* no component */
            children: [
              {
                path: '',
                name: '/system/configuration/customfields',
                component: () => import('/www/resources/js/pages/internal/system/configuration/customfields/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: ':id/edit',
                name: '/system/configuration/customfields/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/system/configuration/customfields/[id].edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'device',
            /* internal name: '/system/configuration/device' */
            /* no component */
            children: [
              {
                path: 'manufacturer',
                /* internal name: '/system/configuration/device/manufacturer' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/device/manufacturer',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/device/manufacturer/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/device/manufacturer/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/device/manufacturer/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'temperatureRoundGroup',
                /* internal name: '/system/configuration/device/temperatureRoundGroup' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/device/temperatureRoundGroup',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/device/temperatureRoundGroup/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/device/temperatureRoundGroup/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/device/temperatureRoundGroup/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'type',
                /* internal name: '/system/configuration/device/type' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/device/type',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/device/type/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/device/type/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/device/type/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          },
          {
            path: 'finance',
            /* internal name: '/system/configuration/finance' */
            /* no component */
            children: [
              {
                path: 'costHeading',
                /* internal name: '/system/configuration/finance/costHeading' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/finance/costHeading',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/finance/costHeading/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/finance/costHeading/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/finance/costHeading/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'invoiceCheck',
                /* internal name: '/system/configuration/finance/invoiceCheck' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/finance/invoiceCheck',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/finance/invoiceCheck/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/finance/invoiceCheck/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/finance/invoiceCheck/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'invoiceNumberQueue',
                /* internal name: '/system/configuration/finance/invoiceNumberQueue' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/finance/invoiceNumberQueue',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/finance/invoiceNumberQueue/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/finance/invoiceNumberQueue/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/finance/invoiceNumberQueue/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          },
          {
            path: 'general',
            /* internal name: '/system/configuration/general' */
            /* no component */
            children: [
              {
                path: 'departments',
                /* internal name: '/system/configuration/general/departments' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/general/departments',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/general/departments/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/general/departments/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/general/departments/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'permissions',
                /* internal name: '/system/configuration/general/permissions' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/general/permissions',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/general/permissions/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'roles',
                /* internal name: '/system/configuration/general/roles' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/general/roles',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/general/roles/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/general/roles/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/general/roles/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/view',
                    name: '/system/configuration/general/roles/[id]/view',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/general/roles/[id].view.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: 'map',
                    /* internal name: '/system/configuration/general/roles/map' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '/system/configuration/general/roles/map',
                        component: () => import('/www/resources/js/pages/internal/system/configuration/general/roles/map/index.vue'),
                        /* no children */
                        meta: {
                          "sector": "internal",
                          "allowed_user_types": [
                            "employee"
                          ]
                        }
                      },
                      {
                        path: ':id/edit',
                        name: '/system/configuration/general/roles/map/[id]/edit',
                        component: () => import('/www/resources/js/pages/internal/system/configuration/general/roles/map/[id].edit.vue'),
                        /* no children */
                        meta: {
                          "sector": "internal",
                          "allowed_user_types": [
                            "employee"
                          ]
                        }
                      }
                    ],
                  }
                ],
              },
              {
                path: 'users',
                /* internal name: '/system/configuration/general/users' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/general/users',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/general/users/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/general/users/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/general/users/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          },
          {
            path: 'lims',
            /* internal name: '/system/configuration/lims' */
            /* no component */
            children: [
              {
                path: 'orderfieldmapping',
                /* internal name: '/system/configuration/lims/orderfieldmapping' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/lims/orderfieldmapping',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/lims/orderfieldmapping/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/lims/orderfieldmapping/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/lims/orderfieldmapping/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'product',
                /* internal name: '/system/configuration/lims/product' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/lims/product',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/lims/product/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/lims/product/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/lims/product/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          },
          {
            path: 'logbook',
            /* internal name: '/system/configuration/logbook' */
            /* no component */
            children: [
              {
                path: 'categories',
                /* internal name: '/system/configuration/logbook/categories' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/logbook/categories',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/logbook/categories/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/logbook/categories/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/logbook/categories/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'communicationtype',
                /* internal name: '/system/configuration/logbook/communicationtype' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/logbook/communicationtype',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/logbook/communicationtype/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/logbook/communicationtype/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/logbook/communicationtype/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          },
          {
            path: 'productportfolio',
            /* internal name: '/system/configuration/productportfolio' */
            /* no component */
            children: [
              {
                path: 'category',
                /* internal name: '/system/configuration/productportfolio/category' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/category',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/category/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/category/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/category/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'component',
                /* internal name: '/system/configuration/productportfolio/component' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/component',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/component/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/component/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/component/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'conformitylevel',
                /* internal name: '/system/configuration/productportfolio/conformitylevel' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/conformitylevel',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/conformitylevel/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/conformitylevel/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/conformitylevel/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'family',
                /* internal name: '/system/configuration/productportfolio/family' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/family',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/family/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/family/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/family/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'group',
                /* internal name: '/system/configuration/productportfolio/group' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/group',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/group/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/group/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/group/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'lab',
                /* internal name: '/system/configuration/productportfolio/lab' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/lab',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/lab/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/lab/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/lab/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'matrix',
                /* internal name: '/system/configuration/productportfolio/matrix' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/matrix',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/matrix/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/matrix/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/matrix/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'method',
                /* internal name: '/system/configuration/productportfolio/method' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/method',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/method/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/method/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/method/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'product',
                /* internal name: '/system/configuration/productportfolio/product' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/product',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/product/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/product/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/product/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/view',
                    name: '/system/configuration/productportfolio/product/[id]/view',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/product/[id].view.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'submatrix',
                /* internal name: '/system/configuration/productportfolio/submatrix' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/submatrix',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/submatrix/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/submatrix/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/submatrix/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'technique',
                /* internal name: '/system/configuration/productportfolio/technique' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/technique',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/technique/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/technique/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/technique/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'type',
                /* internal name: '/system/configuration/productportfolio/type' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/type',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/type/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/type/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/type/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'unit',
                /* internal name: '/system/configuration/productportfolio/unit' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/unit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/unit/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/unit/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/unit/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'variant',
                /* internal name: '/system/configuration/productportfolio/variant' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/configuration/productportfolio/variant',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/variant/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/edit',
                    name: '/system/configuration/productportfolio/variant/[id]/edit',
                    component: () => import('/www/resources/js/pages/internal/system/configuration/productportfolio/variant/[id].edit.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          }
        ],
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'datamanager',
        name: '/system/datamanager:parent',
        component: () => import('/www/resources/js/pages/internal/system/datamanager.vue'),
        children: [
          {
            path: '',
            name: '/system/datamanager',
            component: () => import('/www/resources/js/pages/internal/system/datamanager/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'lims',
            /* internal name: '/system/datamanager/lims' */
            /* no component */
            children: [
              {
                path: 'analyse-components',
                /* internal name: '/system/datamanager/lims/analyse-components' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/datamanager/lims/analyse-components',
                    component: () => import('/www/resources/js/pages/internal/system/datamanager/lims/analyse-components/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/view',
                    name: '/system/datamanager/lims/analyse-components/[id]/view',
                    component: () => import('/www/resources/js/pages/internal/system/datamanager/lims/analyse-components/[id].view.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'analyse-versions',
                /* internal name: '/system/datamanager/lims/analyse-versions' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/datamanager/lims/analyse-versions',
                    component: () => import('/www/resources/js/pages/internal/system/datamanager/lims/analyse-versions/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/view',
                    name: '/system/datamanager/lims/analyse-versions/[id]/view',
                    component: () => import('/www/resources/js/pages/internal/system/datamanager/lims/analyse-versions/[id].view.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              },
              {
                path: 'analyses',
                /* internal name: '/system/datamanager/lims/analyses' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/system/datamanager/lims/analyses',
                    component: () => import('/www/resources/js/pages/internal/system/datamanager/lims/analyses/index.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  },
                  {
                    path: ':id/view',
                    name: '/system/datamanager/lims/analyses/[id]/view',
                    component: () => import('/www/resources/js/pages/internal/system/datamanager/lims/analyses/[id].view.vue'),
                    /* no children */
                    meta: {
                      "sector": "internal",
                      "allowed_user_types": [
                        "employee"
                      ]
                    }
                  }
                ],
              }
            ],
          }
        ],
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'display',
        name: '/system/display:parent',
        component: () => import('/www/resources/js/pages/internal/system/display.vue'),
        children: [
          {
            path: '',
            name: '/system/display',
            component: () => import('/www/resources/js/pages/internal/system/display/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id/edit',
            name: '/system/display/[id]/edit',
            component: () => import('/www/resources/js/pages/internal/system/display/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'active-devices',
            name: '/system/display/active-devices',
            component: () => import('/www/resources/js/pages/internal/system/display/active-devices.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'enroll',
            /* internal name: '/system/display/enroll' */
            /* no component */
            children: [
              {
                path: '',
                name: '/system/display/enroll',
                component: () => import('/www/resources/js/pages/internal/system/display/enroll/index.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      },
      {
        path: 'monitoring',
        name: '/system/monitoring:parent',
        component: () => import('/www/resources/js/pages/internal/system/monitoring.vue'),
        children: [
          {
            path: '',
            name: '/system/monitoring',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'audit/labhub',
            name: '/system/monitoring/audit/labhub',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/audit.labhub.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'audit/yhub',
            name: '/system/monitoring/audit/yhub',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/audit.yhub.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'connect',
            /* internal name: '/system/monitoring/connect' */
            /* no component */
            children: [
              {
                path: 'exact',
                name: '/system/monitoring/connect/exact',
                component: () => import('/www/resources/js/pages/internal/system/monitoring/connect/exact.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'debug',
            /* internal name: '/system/monitoring/debug' */
            /* no component */
            children: [
              {
                path: 'api',
                name: '/system/monitoring/debug/api',
                component: () => import('/www/resources/js/pages/internal/system/monitoring/debug/api.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'serial',
                name: '/system/monitoring/debug/serial',
                component: () => import('/www/resources/js/pages/internal/system/monitoring/debug/serial.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'external-jobs',
            name: '/system/monitoring/external-jobs',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/external-jobs.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'files',
            name: '/system/monitoring/files',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/files.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'jobs/labhub',
            name: '/system/monitoring/jobs/labhub',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/jobs.labhub.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'jobs/yhub',
            name: '/system/monitoring/jobs/yhub',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/jobs.yhub.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'logs',
            name: '/system/monitoring/logs',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/logs.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'pulse/:server',
            name: '/system/monitoring/pulse/[server]',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/pulse.[server].vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: 'store',
            /* internal name: '/system/monitoring/store' */
            /* no component */
            children: [
              {
                path: 'app',
                name: '/system/monitoring/store/app',
                component: () => import('/www/resources/js/pages/internal/system/monitoring/store/app.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'user',
                name: '/system/monitoring/store/user',
                component: () => import('/www/resources/js/pages/internal/system/monitoring/store/user.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'unmapped-products',
            name: '/system/monitoring/unmapped-products',
            component: () => import('/www/resources/js/pages/internal/system/monitoring/unmapped-products.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
        meta: {
          "sector": "internal",
          "allowed_user_types": [
            "employee"
          ]
        }
      }
    ],
  },
  {
    path: '/temperature',
    /* internal name: '/temperature' */
    /* no component */
    children: [
      {
        path: 'round',
        /* internal name: '/temperature/round' */
        /* no component */
        children: [
          {
            path: ':id/run',
            name: '/temperature/round/[id]/run',
            component: () => import('/www/resources/js/pages/shared/temperature/round/[id].run.vue'),
            /* no children */
            meta: {
              "sector": "shared",
              "allowed_user_types": [
                "customer",
                "employee"
              ]
            }
          }
        ],
      }
    ],
  },
  {
    path: '/time-tracking',
    /* internal name: '/time-tracking' */
    /* no component */
    children: [
      {
        path: 'activity',
        /* internal name: '/time-tracking/activity' */
        /* no component */
        children: [
          {
            path: '',
            name: '/time-tracking/activity',
            component: () => import('/www/resources/js/pages/internal/time-tracking/activity/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id',
            /* internal name: '/time-tracking/activity/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/time-tracking/activity/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/time-tracking/activity/[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/time-tracking/activity/[id]/view',
                component: () => import('/www/resources/js/pages/internal/time-tracking/activity/[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      },
      {
        path: 'goal',
        /* internal name: '/time-tracking/goal' */
        /* no component */
        children: [
          {
            path: ':id/edit',
            name: '/time-tracking/goal/[id]/edit',
            component: () => import('/www/resources/js/pages/internal/time-tracking/goal/[id].edit.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      },
      {
        path: 'shift',
        /* internal name: '/time-tracking/shift' */
        /* no component */
        children: [
          {
            path: '',
            name: '/time-tracking/shift',
            component: () => import('/www/resources/js/pages/internal/time-tracking/shift/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id',
            /* internal name: '/time-tracking/shift/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/time-tracking/shift/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/time-tracking/shift/[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/time-tracking/shift/[id]/view',
                component: () => import('/www/resources/js/pages/internal/time-tracking/shift/[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          },
          {
            path: 'ShiftAssignmentEditor',
            name: '/time-tracking/shift/ShiftAssignmentEditor',
            component: () => import('/www/resources/js/pages/internal/time-tracking/shift/ShiftAssignmentEditor.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          }
        ],
      }
    ],
  },
  {
    path: '/vdm',
    /* internal name: '/vdm' */
    /* no component */
    children: [
      {
        path: 'customer',
        /* internal name: '/vdm/customer' */
        /* no component */
        children: [
          {
            path: '',
            name: '/vdm/customer',
            component: () => import('/www/resources/js/pages/internal/vdm/customer/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id',
            /* internal name: '/vdm/customer/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/vdm/customer/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/vdm/customer/[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      },
      {
        path: 'location',
        /* internal name: '/vdm/location' */
        /* no component */
        children: [
          {
            path: '',
            name: '/vdm/location',
            component: () => import('/www/resources/js/pages/internal/vdm/location/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id',
            /* internal name: '/vdm/location/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/vdm/location/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/vdm/location/[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      },
      {
        path: 'sampling',
        /* internal name: '/vdm/sampling' */
        /* no component */
        children: [
          {
            path: '',
            name: '/vdm/sampling',
            component: () => import('/www/resources/js/pages/internal/vdm/sampling/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id',
            /* internal name: '/vdm/sampling/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/vdm/sampling/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/vdm/sampling/[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/vdm/sampling/[id]/view',
                component: () => import('/www/resources/js/pages/internal/vdm/sampling/[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      },
      {
        path: 'visit',
        /* internal name: '/vdm/visit' */
        /* no component */
        children: [
          {
            path: '',
            name: '/vdm/visit',
            component: () => import('/www/resources/js/pages/internal/vdm/visit/index.vue'),
            /* no children */
            meta: {
              "sector": "internal",
              "allowed_user_types": [
                "employee"
              ]
            }
          },
          {
            path: ':id',
            /* internal name: '/vdm/visit/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/vdm/visit/[id]/edit',
                component: () => import('/www/resources/js/pages/internal/vdm/visit/[id]/edit.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              },
              {
                path: 'view',
                name: '/vdm/visit/[id]/view',
                component: () => import('/www/resources/js/pages/internal/vdm/visit/[id]/view.vue'),
                /* no children */
                meta: {
                  "sector": "internal",
                  "allowed_user_types": [
                    "employee"
                  ]
                }
              }
            ],
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

